// extracted by mini-css-extract-plugin
export default {"btnComm":"buttons_btnComm__gH1TW","btnComm_add":"buttons_btnComm_add__SiNBJ"};